import { FC, MouseEvent } from "react";

import ListItem from "components/ListItem/ListItem";

import { map } from "lodash-es";

const FileList: FC<IFileListProps> = props => {
  const { files, onRemove } = props;

  // LOCAL METHODS
  const removeSelectedFile = (event: MouseEvent, fileName: File["name"]) => {
    onRemove(event, fileName);
  };

  // RENDER
  return (
    <>
      {map(files, file => (
        <ListItem
          className="file-list__item"
          disabled
          icon={{ colorRight: "cta", right: "Trash" }}
          key={file.name}
          noBorderBottom
          text={file.name}
          onRightIconClick={event => removeSelectedFile(event, file.name)}
        />
      ))}
    </>
  );
};

export default FileList;

/* ------------------    TYPES    ------------------ */
interface IFileListProps {
  files: FileList;
  onRemove(event: MouseEvent, fileName: File["name"]): void;
}
